import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-developer-about-us',
  templateUrl: './web-developer-about-us.component.html',
  styleUrls: ['./web-developer-about-us.component.css']
})
export class WebDeveloperAboutUsComponent implements OnInit {

  profile: any = {
    logo: "logo-black-5.png",
    profile: "web-developer"
  };

  page_banner: any = {
    title: "About me",
    profile: "web-developer",
  };

  page_info: any = {
    title: "What I Do",
    image: "famille.jpg",
    description: "Hi ! I was born in Marseille and have lived most of my life in Haute-Savoie and Reunion Island, France. I studied computer science and had the chance to start my professional career with my father in the field of digital printing. I then moved to Switzerland with my future wife where we got married and had a baby girl Charlie. After a few years of work still in digital printing, I decided in 2020 to resume my studies independently to become a web developer."
  };

  member: any = {
    image: "",
    logo: "",
    designation: "",
    age: "36",
    dob: "",
    residence: "Switzerland",
    address: "FARVAGNY, SWITZERLAND",
    email: "BERTRANDPETIT10@GMAIL.COM",
    phone: "+41 79 402 88 04",
    skype: "REBEB974",
    whatsapp: "",
    about_me: "",
    intrests: "",
    name: "",
    study: "",
    highes_degree: "",
    profile: "web-developer"
  };


  services: any = [
    {
      title: "PWA Mobile App",
      description: "My first project was a PWA project for my family. Named Attila, it is a household planner and a list manager such as shopping lists for example.",
    },
    {
      title: "FrontEnd Web Development",
      description: "Mainly developed in Angular 10, my web applications are made with the latest technologies.",
    },
    {
      title: "BackEnd Development",
      description: "NodeJS, Express JS, MongoDB or SQL are mainly the tools I use to develop Rest APIs. They are used for mobile, web or PWA Apps.",
    },
    {
      title: "UI/UX DESIGNER",
      description: "I highly value the user experience so that the navigation and the design are good.",
    },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
